import React, { Component } from "react";
import {Map, Marker, Polyline, GoogleApiWrapper} from 'google-maps-react';
import Select from 'react-select';
import { ButtonToolbar, ToggleButton, ToggleButtonGroup, Navbar } from "react-bootstrap";
import { invokeApig } from '../../libs/awsLib';
import io from 'socket.io-client';
import config from "../../config";
import "./FleetMap.css";

export class FleetMap extends Component {
  constructor(props) {
    super(props);
    this.defaultOptions = [
	  	{ value: 'units', label: 'Vehículo(s)'},
	    { value: 'group', label: 'Grupo de vehículos'},
	    { value: 'all', label: 'Todos los vehículos'}
	  ];
    this.sockets = [];
    this.state = {
      isLoading: true,
      removeSelected: true,
      disabled: false,
      stayOpen: false,
      value: [],
      options: this.defaultOptions,
      events: null,
      markers: []
    };
  }

  componentDidMount() {}

  componentWillUnmount() {
    this.disconnectSockets();
  }

  disconnectSockets() {
    this.sockets.map((socket, index) => {
      socket.disconnect();
      return null;
    });
  }

  getUnits() {
    return invokeApig({
      path: "/unit/find",
      method: "POST",
      body: {
        "page": 0,
        "size": 10
      }
    });
  }

  async showUnits() {
    const options = [];
    try {
      //this.setState({ options: [] });
      const result = await this.getUnits();
      result.Items.map((unit) => {
    	  options.push({
    		  value: unit.device.type + '-' + unit.device.id,//unit.internalNumber,
    		  label: unit.internalNumber
    	  });
    	  return null;
      });
    } catch (e) {
      alert(e);
    }
    this.setState({ options, isLoading: false });
  }

  getTags() {
    return invokeApig({
      path: "/unit/tags"
    });
  }

  async showTags() {
  	const options = [];
  	try {
      this.setState({ options: [] });
      const result = await this.getTags();
      result.map((tag) => {
    	  options.push({
    		  value: tag,
    		  label: tag
    	  });
    	  return null;
      });
    } catch (e) {
      alert(e);
    }
    this.setState({ isLoading: false, options: options });
  }

  handleSelectChange = (value) => {
    if (!value) {
      this.setState({ value: [], markers: [], options: this.defaultOptions });
      return;
    }
    var option = value.length ? value[0].value : '';
    var last = value[value.length - 1];
    switch(option) {
  	  case 'units':
    		if (value.length === 1) {
          this.showUnits();
          this.disconnectSockets();
          this.setState({ markers: [], value: value });
    		} else {
          this.sockets.push(this.socketStart(last));
    		  this.setState({ markers: value, value });
    		}
    		break;
  	  case 'group':
    		if (value.length === 1) {
    	      this.showTags();
    		  this.setState({ markers: [], value });
    		} else {
    		  this.showLastEvent(null, last);
    		  this.setState({ markers: value, value });
    		}
    		break;
  	  case 'all':
  	    this.setState({ value, options: [] });
  	    this.showLastEvent();
  	    break;
  	  default:
  		  this.setState({ value: [], markers: [], options: this.defaultOptions });
  	    break;
    }
  }

  handleUnitChange = (value) => {
    this.setState({value});
  }

  socketStart = (device) => {
    console.log(device.value);
    var socket = io(config.websocket.URL, {secure: true, transports: ['websocket']});
    socket.on('connect', this.handleConnect);
    socket.emit('position', { id: device.value });
    socket.on('message', this.handleEvent);
    socket.on('disconnect', this.handleDisconnect);
    socket.on('connect_error', this.handleError);
    socket.on('connect_timeout', this.handleError);
    return socket;
  }
  handleConnect = () => {
    console.log('socket connected');
    this.setState({ errorMessage: '' });
  }
  handleEvent = (data) => {
    console.log("Nuevo dato: " + JSON.stringify(data));
    //internalNumber, eventDate, latitude, longitude
    const {markers} = this.state;
    if (markers.length && markers.length === 5) {
      markers.shift();
    }
    this.setState({ markers: [...markers, data] });
  }
  handleDisconnect = () => {
    console.log('socket disconnected');
  }
  handleError = () => {
    console.log('socket error');
    this.setState({ errorMessage: 'Error de conexión al servidor' });
  }

  renderMarkers() {
    const { google } = this.props;
    const newBounds = new google.maps.LatLngBounds();
    const map = this.map ? this.map.map : {};
    const length = this.state.markers.length;
    return (
      this.state.markers.map((val, index) => {
        if (val && val.latitude && val.longitude) {
          const lastPosition = {lat: val.latitude, lng: val.longitude, };
          newBounds.extend(lastPosition);
          map.fitBounds(newBounds);
          const head = Math.round(val.heading / 45) + ( index + 1 === length ? 'end' : '' );
          console.log("Heading: " + val.heading + " | calc: " + head);
          return <Marker title={val.eventDate} key={val.eventDate} label={val.internalNumber} position={lastPosition} icon={{ url: "/images/arrow" + head + ".png", anchor: new google.maps.Point(32,32), scaledSize: new google.maps.Size(64,64) }}/>
        }
        return '';
      })
    );
  }
  renderPolylines() {
    const line = [];
    this.state.markers.map((val, index) => {
      if (val && val.latitude && val.longitude) {
        line.push({lat: val.latitude, lng: val.longitude});
      }
    });
    return (
      <Polyline
        path={line}
        strokeColor="#0000FF"
        strokeOpacity={0.8}
        strokeWeight={2} />
    );
  }
  render() {
    const style = {
  	  width: '100%',
  	  height: (window.innerHeight - 95) + 'px'
  	}
    const initialCenter = {
      lat: 0,
      lng: 0
    }

    const { disabled, stayOpen, value, options } = this.state;
    return (
      <div className="FleetMap">
        <div className="select-container">
          <Select
            name="map-select"
            isMulti
            onChange={this.handleSelectChange}
            options={options}
            value={value}
            placeholder="Click para ver opciones"
            noOptionsMessage={()=>{ return "No hay opciones disponibles"}}
          />
        </div>
        <Map
  	      google={this.props.google}
  	      style={style}
  	      initialCenter={initialCenter}
  	      centerAroundCurrentLocation={true}
  	      ref={(map) => this.map = map}
  	      zoom={10}>
		      {this.renderMarkers()}
          {this.renderPolylines()}
        </Map>
        <ButtonToolbar bsClass="mapButtonToolbar">
          <ToggleButtonGroup type="radio" name="range" defaultValue="last">
            <ToggleButton value="last">últ</ToggleButton>
            <ToggleButton value="10m">10m</ToggleButton>
            <ToggleButton value="1h">1h</ToggleButton>
            <ToggleButton value="1d">1d</ToggleButton>
            <ToggleButton value="other">otro</ToggleButton>
          </ToggleButtonGroup>
        </ButtonToolbar>
      </div>
    );
  }
}

export default GoogleApiWrapper({
	  apiKey: (config.API_GOOGLE_MAPS)
})(FleetMap)



// WEBPACK FOOTER //
// ./src/containers/map/FleetMap.js